import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import { Form } from 'react-bootstrap';

import ValidationAlert from '../../../app/components/ValidationAlert';
import FormRow from '../../../app/components/FormRow';
import { CreateUpdatePricingGroupDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface PricingGroupEditorProps {
  id?: string;
  pricingGroup: CreateUpdatePricingGroupDto;
  handleClose?: () => void;
  show?: boolean;
  onCompleted: (
    pricingGroup: CreateUpdatePricingGroupDto,
    id?: string,
  ) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
}

export const PricingGroupEditor: React.FC<PricingGroupEditorProps> = props => {
  const [pricingGroup, setPricingGroup] = useState(props.pricingGroup);
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);

  useEffect(() => {
    if (props.show) {
      setSaveErrors([]);
      setShowSaveErrors(false);
      setPricingGroup(props.pricingGroup);
    }
  }, [props.show, props.pricingGroup, props.id]);

  const createPricingGroup = async () => {
    props
      .onCompleted(pricingGroup, props.id)
      .then(saveStatus => {
        if (!saveStatus.saved) {
          setSaveErrors(saveStatus.errors);
          setShowSaveErrors(true);
          return;
        }
      })
      .catch(error => {
        setSaveErrors(error);
        setShowSaveErrors(true);
      });
  };

  const propertyChange = (obj: Partial<CreateUpdatePricingGroupDto>) => {
    setPricingGroup({ ...pricingGroup, ...obj });
  };

  return (
    <>
      <Modal
        onHide={props.handleClose}
        show={props.show}
        centered={true}
        keyboard={true}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {props.id ? 'Edycja grup cenowych' : 'Dodawanie grup cenowych'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Card className="mb-2">
            <Card.Header>Grupa cenowa</Card.Header>
            <Card.Body>
              <Form className="d-grid gap-3">
                <FormRow controlId="name" label="Nazwa">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={pricingGroup?.name || ''}
                    onChange={e => propertyChange({ name: e.target.value })}
                  />
                </FormRow>

                <FormRow controlId="user_active" label="Aktywna">
                  <Form.Check
                    type="checkbox"
                    checked={pricingGroup?.active ? true : false}
                    onChange={e => propertyChange({ active: e.target.checked })}
                  />
                </FormRow>
              </Form>
            </Card.Body>
          </Card>
          <ValidationAlert
            show={showSaveErrors}
            errors={saveErrors}
            className="mt-3"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={props.handleClose}>
            Zamknij
          </Button>
          <Button variant="outline-primary" onClick={createPricingGroup}>
            Zapisz
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
